// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c2cd1f3","455":"8d9147db","977":"924ae6dd"}[chunkId] + ".chunk.js";
};